import { useState, useMemo } from 'react';
import './FAQ.css';


const faqs = [
  {
    question: 'What exactly does Aurelix do?',
    answer:
      "Aurelix is a consulting and growth enablement firm. We connect your ads, funnels, sales data, and operations into one integrated system — so you always know what's working, what's wasting money, and what to do next. We specialise in Performance Marketing, Website Development, Data Analytics, and AI Automation.",
  },
  {
    question: 'Who do you typically work with?',
    answer:
      'We work with D2C founders, e-commerce operators, and growth-stage businesses who are tired of agencies that optimise for impressions instead of income.',
  },
  {
    question: 'How is Aurelix different from a regular agency?',
    answer:
      "We don't just run ads or build websites in isolation. We connect every piece — paid media, website, analytics, and automation — into one growth system.",
  },
  {
    question: 'What does your engagement look like?',
    answer:
      'We begin with a discovery call, identify bottlenecks, then build a custom roadmap with clear execution and reporting.',
  },
  {
    question: 'Do you work with businesses outside India?',
    answer:
      'Yes. We work with brands across India, the United States, and the United Kingdom.',
  },
  {
    question: 'How long before we see results?',
    answer:
      'Paid campaigns usually show meaningful data within 2–4 weeks. CRO and funnel improvements show within 4–8 weeks.',
  },
  {
    question: 'What is your pricing?',
    answer:
      'Pricing is project-based and tailored to your business goals, timelines, and growth requirements.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">



      {/* DARK OVERLAY */}
      <div className="faq-overlay"></div>

      {/* CONTENT */}
      <div className="faq-content">

        <div className="section-header faq-header">
          <p className="section-label">
            Got Questions?
          </p>

          <h2>
            <span style={{ color: '#ec2b28' }}>
              FAQ
            </span>
          </h2>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'active' : ''
                }`}
            >
              <button
                className="faq-question-btn"
                onClick={() => toggleFAQ(index)}
              >
                <span className="faq-index">
                  [{String(index + 1).padStart(2, '0')}]
                </span>

                <span className="faq-question">
                  {faq.question}
                </span>

                <span className="faq-icon">
                  {openIndex === index ? '×' : '+'}
                </span>
              </button>

              <div
                className={`faq-answer-wrapper ${openIndex === index ? 'open' : ''
                  }`}
              >
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}